import {
  DescriptionAndContactInfo,
  Divider,
  StatsCard,
} from 'components/NewCompanyPage/Sidebar/shared'
import { MapCard } from 'components/NewCompanyPage/Sidebar/shared/MapCard'
import { formatAddress } from 'utils/formatting'

type AddressInfo = {
  street?: string
  city?: string
  state?: string
  zipcode?: string
  latitude?: number
  longitude?: number
}

/**
 * Build the location places content for pages
 */
export function buildLocationPlacesContent({
  addressInfo,
  phone,
  googlePlaceUrl,
}: {
  addressInfo: AddressInfo
  phone?: string
  googlePlaceUrl?: string
}): React.ReactNode[] {
  // Build location details tab content
  const locationDetailsTabContent: React.ReactNode[] = []

  locationDetailsTabContent.push(
    <MapCard
      key="map-card"
      latitude={addressInfo.latitude}
      longitude={addressInfo.longitude}
    />,
    <DescriptionAndContactInfo
      key="description-contact"
      address={
        formatAddress({
          street: addressInfo?.street,
          city: addressInfo?.city,
          state: addressInfo?.state,
          zip: addressInfo?.zipcode,
        }) ?? undefined
      }
      googlePlaceUrl={googlePlaceUrl}
      phone={phone || undefined}
    />,
    <Divider key="divider-1" />,
    <StatsCard
      key="location-info"
      stats={[
        {
          label: 'Phone',
          value: phone || 'N/A',
        },
        {
          label: 'Street',
          value: addressInfo.street || 'N/A',
        },
        {
          label: 'City',
          value: addressInfo.city || 'N/A',
        },
        {
          label: 'State',
          value: addressInfo.state || 'N/A',
        },
        {
          label: 'ZIP Code',
          value: addressInfo.zipcode || 'N/A',
        },
      ]}
    />
  )

  return locationDetailsTabContent
}
